import { memo } from "react";

import { ProductCardPlaceholder } from "@components/ProductCard";
import { type TTailwindString, tw } from "classnames";

const styles = {
  base: tw(
    "m-0",
    "grid",
    "list-none",
    "grid-flow-row-dense",
    "grid-cols-2",
    "gap-x-4",
    "gap-y-8" as TTailwindString,
    "p-0",
    "md:grid-flow-row",
    "md:gap-x-6",
    "md:gap-y-11",
    "mg:grid-cols-3",
    "pb-15"
  ),
};

const CollectionGridPlaceholderBase = () => (
  <ol className={styles.base}>
    {Array.from({ length: 6 }, (_, index) => (
      <ProductCardPlaceholder key={`placeholder-${index}`} />
    ))}
  </ol>
);

export const CollectionGridPlaceholder = memo(CollectionGridPlaceholderBase);
